import { render, staticRenderFns } from "./SysGatewayRouteList.vue?vue&type=template&id=22e351a7&"
import script from "./SysGatewayRouteList.vue?vue&type=script&lang=js&"
export * from "./SysGatewayRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports